import { supabase } from './client';

/**
 * Servicio para gestionar los perfiles de DJ
 * Incluye funciones para obtener y actualizar perfiles y biografías
 */

/**
 * Obtiene la biografía del DJ
 * @param {string} djName - Nombre de usuario del DJ
 * @returns {Promise<Object>} - Biografía e información del DJ
 */
export const getDjBio = async (djName) => {
    try {
        const { data, error } = await supabase
            .from('djs')
            .select('*')
            .eq('username', djName)
            .single();

        if (error) throw error;
        if (!data) throw new Error('No se encontró información para este DJ');

        // Mapear a la estructura esperada
        return {
            id: data.id,
            fields: {
                username: data.username,
                // Añadir otros campos si son necesarios para la biografía
                // Por ahora mapeamos lo básico que existía
            }
        };
    } catch (error) {
        console.error('Error al obtener la biografía del DJ:', error);
        throw error;
    }
};
